export default {
  computed: {
    geoipEnabled() {
      return !!this.geoipHostname
    },

    geoipHostname() {
      return this.agraConfiguration.geoipHostname
    }
  },

  created() {
    // Kick off the geoip call that will set agraConfiguration.locationSearchBias.country, which
    // we'll want to pass along with location search requests.
    // Q: What happens if this isn't done by the time the user makes a search request?
    // A: That's fine, it's not a big deal, their search just won't have the country biasing on it.
    if (this.geoipEnabled) {
      this.setLocationSearchBiasCountryFromGeoip()
    }
  },

  methods: {
    fetchGeoipInformation() {
      return new Promise((resolve) => {
        // Q: Why not use our ajax helper?
        // A: It runs into a CORS issue trying to make this external request
        fetch(`https://${this.geoipHostname}/geoip`).then((resp) => {
          resp.json().then((jsonResponse) => {
            resolve(jsonResponse)
          })
        })
      })
    },

    setLocationSearchBiasCountryFromGeoip() {
      if (!this.agraConfiguration.locationSearchBias.country) {
        this.fetchGeoipInformation().then((jsonResponse) => {
          const countryCode = jsonResponse.country_code.toUpperCase()
          this.agraConfiguration.locationSearchBias.country = countryCode
        })
      }
    }
  }
}
